import { render, staticRenderFns } from "./restocked.vue?vue&type=template&id=0c5df951&scoped=true&"
import script from "./restocked.vue?vue&type=script&lang=js&"
export * from "./restocked.vue?vue&type=script&lang=js&"
import style0 from "./restocked.vue?vue&type=style&index=0&id=0c5df951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5df951",
  null
  
)

export default component.exports